import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WallboxFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M5.99961 2.39844C4.67413 2.39844 3.59961 3.47295 3.59961 4.79844V16.7984C3.59961 18.1239 4.67413 19.1984 5.99961 19.1984H11.0996C11.0996 19.7425 11.2554 20.5385 11.7492 21.2243C12.2761 21.9561 13.1463 22.4984 14.3996 22.4984H17.9996C18.5723 22.4984 19.282 22.3248 19.8449 21.7458C20.4086 21.166 20.6996 20.3088 20.6996 19.1984V15.3581H21.2572L19.4087 7.65592L15.5996 6.38623V4.79844C15.5996 3.47295 14.5251 2.39844 13.1996 2.39844H5.99961ZM15.5996 10.7377V16.7984C15.5996 18.1239 14.5251 19.1984 13.1996 19.1984H12.8996C12.8996 19.4544 12.9838 19.8584 13.21 20.1726C13.4031 20.4408 13.7329 20.6984 14.3996 20.6984H17.9996C18.2269 20.6984 18.4172 20.6321 18.5543 20.4911C18.6906 20.3509 18.8996 20.008 18.8996 19.1984V15.3581H18.3609L16.6832 11.0086L15.5996 10.7377ZM6.59961 8.69844L12.5996 8.69844V6.89844L6.59961 6.89844L6.59961 8.69844Z"
      />
    </SvgIcon>
  );
});
